import { useEffect } from 'react'
import { runInAction } from 'mobx'
import { checkFilterSmartView } from 'entities/SmartViews/lib/checkFilterSmartView'
import { WebsocketEvent } from 'entities/WebSocket'
import { type IResponseConversation } from 'entities/Conversation/api/types'
import { Conversation } from 'entities/Conversation/model/Conversation'
import { useEntitiesContext } from 'entities/EntitiesExport'
import type { ILocalTypeInbox } from 'entities/Inbox'
import type { ConversationListStore } from 'pages/conversations/ui/ConversationList'

export const useEventConversationReassigned = (
  conversationListStore: ConversationListStore,
  view: ILocalTypeInbox
) => {
  const entities = useEntitiesContext()
  const { conversationStore } = entities
  const { filtersStore } = conversationListStore
  const handler = (data: IResponseConversation) => {
    const item = new Conversation(data, entities)

    const update = () => {
      const checked = Boolean(conversationStore.getItem(data.id)?.checked)
      conversationStore.updateItem(data)
      conversationStore.getItem(data.id)?.handleChecked(checked)
      conversationListStore.updateItemOrder(item.id, 0, true)
    }

    runInAction(() => {
      // Smart view
      if (view === 'smart_view') {
        const smartView = entities.inboxesStore.localInboxes.currentSmartView

        if (!smartView) return
        if (!checkFilterSmartView(item.smartViewFilterParams, smartView.filters)) return
        if (!filtersStore.isShowConversation(item)) return

        update()

        return
      }
    })
  }

  useEffect(() => entities.websocket.on(WebsocketEvent.ConversationReassigned, handler), [view])
}
